import { LucaEngListModel } from 'countable@model';
import { ContextGlTbModel, ContextGLYearModel, ContextOtherApiModel, GroupModel, SaveOtherApiModel } from '../model/ai/context.model';

export class AiFreeContextUtility {
    static numberToNotationK(value: number): number {
        return parseFloat((value / 1000).toFixed(1));
    }

  static updateDataSource(data: ContextGlTbModel[], filteredKeys: ContextGLYearModel[], len: number) {
        let usageToken = {
            totalTokens: 0,
            selectedRows: 0
        }
        data.forEach(item => {
            item.units = 0;
            item.totalUnits = 0;
            if (filteredKeys[0] && filteredKeys[1] && filteredKeys[2] && len === 3) {
                let totalUnits = (item[filteredKeys[0].gl] + item[filteredKeys[1].gl] + item[filteredKeys[2].gl]);
                item.units = totalUnits >= 1000 ?
                    this.numberToNotationK(item[filteredKeys[0].gl] + item[filteredKeys[1].gl] + item[filteredKeys[2].gl]) :
                    totalUnits;
                item.totalUnits = totalUnits;
            } else if (filteredKeys[0] && filteredKeys[1] && len === 2) {
                let totalUnits = (item[filteredKeys[0].gl] + item[filteredKeys[1].gl]);
                item.units = totalUnits >= 1000 ?
                    this.numberToNotationK(item[filteredKeys[0].gl] + item[filteredKeys[1].gl]) :
                    totalUnits;
                item.totalUnits = totalUnits;
            } else if (filteredKeys[0] && len === 1) {
                item.units = item[filteredKeys[0].gl] >= 1000 ? this.numberToNotationK(item[filteredKeys[0].gl]) : item[filteredKeys[0].gl];
                item.totalUnits = item[filteredKeys[0].gl];
            }
            usageToken.totalTokens += item.isRowChecked ? item.totalUnits : 0;
            usageToken.selectedRows += item.isRowChecked ? 1 : 0;
        });
        return { usageToken: usageToken, dataSource: data };

    }

    static setPercentage(maxTokens: number, estimatedTokens: number) {
        // Dynamically change color based on percentage
        let color = '#6ce9a6';
        let percent = 0;
        if (estimatedTokens) {
            percent = Math.round((estimatedTokens / maxTokens) * 100);
            color = percent >= 100 ? '#dc6803' : '#6ce9a6';
        }
        return { percent: percent, color: color };
    }

  static updateTbDataSource(data: ContextGlTbModel[], filteredKeys: ContextGLYearModel[], len: number) {
    let usageToken = {
      totalTokens: 0,
      selectedRows: 0
    };
    data.forEach(item => {
      item.units = 0;
      item.totalUnits = 0;
      if (filteredKeys[0] && filteredKeys[1] && filteredKeys[2] && len === 3) {
        let totalUnits = (item[filteredKeys[0].tb] + item[filteredKeys[1].tb] + item[filteredKeys[2].tb]);
        item.units = totalUnits >= 1000 ?
          this.numberToNotationK(item[filteredKeys[0].tb] + item[filteredKeys[1].tb] + item[filteredKeys[2].tb]) :
          totalUnits;
        item.totalUnits = totalUnits;
      } else if (filteredKeys[0] && filteredKeys[1] && len === 2) {
        let totalUnits = (item[filteredKeys[0].tb] + item[filteredKeys[1].tb]);
        item.units = totalUnits >= 1000 ?
          this.numberToNotationK(item[filteredKeys[0].tb] + item[filteredKeys[1].tb]) :
          totalUnits;
        item.totalUnits = totalUnits;
      } else if (filteredKeys[0] && len === 1) {
        item.units = item[filteredKeys[0].tb] >= 1000 ? this.numberToNotationK(item[filteredKeys[0].tb]) : item[filteredKeys[0].tb];
        item.totalUnits = item[filteredKeys[0].tb];
      }
      usageToken.totalTokens += item.isRowChecked ? item.totalUnits : 0;
      usageToken.selectedRows += item.isRowChecked ? 1 : 0;
    });
    return {usageToken: usageToken, dataSource: data};
  }

  static transformContextInfo(info: ContextGlTbModel[], groups: GroupModel[]): ContextGlTbModel[] {
    return info?.map(r => {
      return {
        ...r,
        totalUnits: 0,
        units: 0,
        isRowChecked: false,
        groupName: this.getGroupBasedOnId(r?.finGroupId, groups)

      };
    });
  }

  static getGroupBasedOnId(id: number, groups: GroupModel[]) {
    const group = groups.find(g => g?.id === id);
    if (group?.name) {
      return group?.name
    }
  }

  static filterOtherApiFetchList(apiInfo: ContextOtherApiModel[], engInfo: LucaEngListModel): SaveOtherApiModel {
      const filterSelectedApi = apiInfo?.filter(a => a?.isLoading === true)
        ?.map(s => <ContextOtherApiModel>{
          apiId: s.apiId,
          action: 'select'
        });
      return  {
      chat_id:  null,
      engagement_id: engInfo?.engId,
      file_path: null,
      integration_id: engInfo?.integrationId,
      year_end_date: engInfo?.engYearEnd,
      selections: filterSelectedApi
    }
  }

  static getYearSelection(
    years: ContextGLYearModel[],
    selectedAPI: ContextOtherApiModel
  ): { content: string; tokens: number } {
    let content = '';
    let totalTokens = 0;

    // Check isCY selection
    const isCYSelected = years.find(y => y.value === 'isCY' && y.isChecked);
    if (isCYSelected && selectedAPI.cy?.content) {
      content += selectedAPI.cy.content;
      totalTokens += selectedAPI.cy.tokens || 0;
    }

    // Check isPY1 selection
    const isPY1Selected = years.find(y => y.value === 'isPY1' && y.isChecked);
    if (isPY1Selected && selectedAPI.py1?.content) {
      if (content.length > 0) {
        content += '\n';
      } // Add newline only if content exists
      content += selectedAPI.py1.content;
      totalTokens += selectedAPI.py1.tokens || 0;
    }

    // Check isPY2 selection
    const isPY2Selected = years.find(y => y.value === 'isPY2' && y.isChecked);
    if (isPY2Selected && selectedAPI.py2?.content) {
      if (content.length > 0) {
        content += '\n';
      }
      content += selectedAPI.py2.content;
      totalTokens += selectedAPI.py2.tokens || 0;
    }

    return {
      content,
      tokens: totalTokens
    };
  }
}
